module.exports = __webpack_public_path__ + "img/128.e0b58b7c.jpg";